import React, { useEffect, useState, useRef } from "react";
import { Container, Image, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./religion.css";

import backarrow from "../../../assets/images/backarrow.jpg";
import logo from "../../../assets/images/MTDlogo.png";

import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from '../Stepper';
import { API_URL } from "../../../api";
import { useCookies } from "../../../hooks/useCookies";

export const Religion = () => {
  const isFetched = useRef(false);
  const { getCookie } = useCookies();
  const token = getCookie("token");
  const [allReligions, setAllReligions] = useState([]);
  const [selectedReligion, setSelectedReligion] = useState(null);
  const [allLanguages, setAllLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [errorMessage, setErrorMessege] = useState("");
  const [lerrorMessage, setLErrorMessege] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    if (!token) return;
    fetchReligions();
    fetchLanguages();
  }, [token, allReligions, allLanguages]);

  const fetchReligions = () => {
    fetch(`${API_URL}customer/users/religions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setAllReligions(data.religions);
        if (data.userReligion) {
          setSelectedReligion(data.userReligion.name);
        }
      })
      .catch((error) => {
        console.error("Error fetching religions:", error);
      });
  };
  const fetchLanguages = () => {
    fetch(`${API_URL}customer/users/language`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setAllLanguages(data.languages);
      })
      .catch((error) => {
        console.error("Error fetching languages:", error);
      });

    fetch(`${API_URL}customer/users/userlanguage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSelectedLanguages(
          data.selectedLanguages.map((lang) => lang.language_id)
        );
      })
      .catch((error) => {
        console.error("Error fetching user languages:", error);
      });
  };

  const handleLanguageClick = (languageId) => {
    setSelectedLanguages((prevSelected) => {
      if (prevSelected.includes(languageId)) {
        return prevSelected.filter((id) => id !== languageId);
      } else {
        return [...prevSelected, languageId];
      }
    });
  };

  const handleReligionClick = async (e) => {
    e.preventDefault();

    // Reset error messages
    setErrorMessege("");
    setLErrorMessege("");


    if (!selectedReligion) {
      setErrorMessege("*Please make a selection.");
      return;
    }
    if (!selectedLanguages || selectedLanguages.length < 1) {
      setLErrorMessege("*Please make a selection.");
      return;
    }

    const religionId = allReligions.find(
      (r) => r.name === selectedReligion
    )?.id;

    if (!religionId) {
      setErrorMessege("*Invalid religion selection.");
      return;
    }

    try {
      setLoading(true);

      // Update religion
      const religionRes = await fetch(`${API_URL}customer/users/religions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: JSON.stringify({ religionId }),
      });

      if (!religionRes.ok) {
        throw new Error("Failed to update religion.");
      }

      // Update preference for religion ID
      const preferenceRes = await fetch(
        `${API_URL}customer/user/preferences/save/religion_id`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("token")}`,
          },
          body: JSON.stringify({ value: religionId }),
        }
      );

      if (!preferenceRes.ok) {
        throw new Error("Failed to save religion preference.");
      }

      // Update languages
      const languageRes = await fetch(`${API_URL}customer/users/language`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: JSON.stringify({ languages: selectedLanguages }),
      });

      if (!languageRes.ok) {
        throw new Error("Failed to update languages.");
      }

      // Success - Navigate
      navigate("/edu");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="religion-container">
      <div className="religion-bg">
        <Image className="responsive-bg" src={responsivebg}></Image>
      </div>
      <Container className="religion-main">
        <Container className="religion-content">
          <Container className="logo-progressbar8">
            <Container className="logo-arrow8">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()} alt="Back"
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="Religion" />
          </Container>
          <div className="container-div">

            <Container className="religion-details">
              <div className="container-child1">

                <div className="your-religion">
                  <Container className="religion-text">
                    <p>What are your religious beliefs?</p>
                  </Container>

                  <Container className="all-religion">
                    {allReligions.map((religion, index) => (
                      <div
                        key={index}
                        className={`religion-item ${selectedReligion === religion.name ? "active" : ""
                          }`}
                        onClick={() => setSelectedReligion(religion.name)}
                      >
                        {religion.name}
                      </div>
                    ))}
                  </Container>
                  <div style={{ marginTop: "-20px" }}>
                    {errorMessage && (
                      <p className="text-danger error-message">{errorMessage}</p>
                    )}
                  </div>
                </div>
                <div className="your-lang mt-4">
                  <Container className="religion-text">
                    <p>What language(s) do you speak?</p>
                  </Container>
                  <Container className="all-lang">
                    {allLanguages.map((language, index) => (
                      <div
                        key={index}
                        className={`lang-item ${selectedLanguages.includes(language.id) ? "active" : ""
                          }`}
                        onClick={() => handleLanguageClick(language.id)}
                      >
                        {language.name}
                      </div>
                    ))}
                  </Container>
                  <div style={{ marginTop: "-13px", marginLeft: "20px" }}>
                    {lerrorMessage && (
                      <p className="text-danger error-message">{lerrorMessage}</p>
                    )}
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div
            className="d-flex justify-content-center next-btn"
          >
            <button type="submit" className="global-next-bottom-fix-btn"
              onClick={handleReligionClick}
              disabled={loading}>
              {loading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                "Next"
              )}
            </button>
          </div>
        </Container>
      </Container>
    </div>
  );
};
